import { lazy } from "react";

const Win = lazy(() => import("../../pages/gameover/pages/win/Win"));

export { Win };
